module.exports = __webpack_public_path__ + "img/new-logo-small.591807ff.png";